import dataAPI from '@/services/data-api'

const state = {
  employees: [],
  fioEmployees: [],
  workPlaceEmployees: [],
  recreationCenters: [],
  recreationCenterCategories: [],
  recreationCenterDays: [],
  recreationCenterDayStatus: '',
  spaTreatments: [],
  spaTreatmentCategories: [],
  spaTreatmentDays: [],
  spaTreatmentDayStatus: '',
  dispensarys: [],
  dispensaryCategories: [],
  dispensaryDays: [],
  dispensaryDayStatus: '',
  summerHealthCamps: [],
  summerHealthCampCategories: [],
  summerHealthCampDays: [],
  summerHealthCampDayStatus: '',
  coInitiatorEmployees: [],
}

const getters = {
  /* eslint-disable no-shadow */
  employees: state => state.employees,
  fioEmployees: state => state.fioEmployees,
  workPlaceEmployees: state => state.workPlaceEmployees,
  recreationCenters: state => state.recreationCenters,
  recreationCenterCategories: state => state.recreationCenterCategories,
  recreationCenterDays: state => state.recreationCenterDays,
  recreationCenterDayStatus: state => state.recreationCenterDayStatus,
  spaTreatments: state => state.spaTreatments,
  spaTreatmentCategories: state => state.spaTreatmentCategories,
  spaTreatmentDays: state => state.spaTreatmentDays,
  spaTreatmentDayStatus: state => state.spaTreatmentDayStatus,
  dispensarys: state => state.dispensarys,
  dispensaryCategories: state => state.dispensaryCategories,
  dispensaryDays: state => state.dispensaryDays,
  dispensaryDayStatus: state => state.dispensaryDayStatus,
  summerHealthCamps: state => state.summerHealthCamps,
  summerHealthCampCategories: state => state.summerHealthCampCategories,
  summerHealthCampDays: state => state.summerHealthCampDays,
  summerHealthCampDayStatus: state => state.summerHealthCampDayStatus,
  coInitiatorEmployees: state => state.coInitiatorEmployees,
}

const mutations = {
  set(state, { type, value }) {
    state[type] = value
  },
}

const actions = {
  getUser({ commit }, iin) {
    return dataAPI.employee.iin(iin).then((result) => {
      const employees = result.data;
      commit('set', { type: 'employees', value: employees })
    })
  },
  getFioUser({ commit }, fio) {
    return dataAPI.employee.fioLike(fio).then((result) => {
      const fioEmployees = result.data;
      commit('set', { type: 'fioEmployees', value: fioEmployees })
    })
  },
  getCoInitiator({ commit }, tabNo) {
    return dataAPI.employee.tabNo(tabNo).then((result) => {
      const coInitiatorEmployees = result.data;
      commit('set', { type: 'coInitiatorEmployees', value: coInitiatorEmployees })
    })
  },
  getWorkPlaceEmloyees({ commit }, workPlaceId) {
    return dataAPI.employee.workPlaceEmployees(workPlaceId).then((result) => {
      const workPlaceEmployees = result.data;
      commit('set', { type: 'workPlaceEmployees', value: workPlaceEmployees })
    })
  },
  getRecreationCenterAll({ commit }) {
    return dataAPI.recreationCenter.fetchAll().then((result) => {
      const recreationCenterIds = [];
      const recreationCenters = [];
      result.data.forEach(function(recreationCenter){
        if(recreationCenterIds.indexOf(recreationCenter.id) === -1){
          recreationCenters.push(recreationCenter);
          recreationCenterIds.push(recreationCenter.id);
        }
      });
      commit('set', { type: 'recreationCenters', value: recreationCenters })
    })
  },
  getRecreationCenters({ commit }, data) {
    return dataAPI.recreationCenter.fetchFound(data).then((result) => {
      const recreationCenterIds = [];
      const recreationCenters = [];
      result.data.forEach(function(recreationCenter){
        if(recreationCenterIds.indexOf(recreationCenter.id) === -1){
          recreationCenters.push(recreationCenter);
          recreationCenterIds.push(recreationCenter.id);
        }
      });
      commit('set', { type: 'recreationCenters', value: recreationCenters })
    })
  },
  getRecreationCenterCategories({ commit }, recreationCenterData) {
    return dataAPI.recreationCenter.fetchCategoriesNew(recreationCenterData.recreationCenterId, recreationCenterData.regionId, recreationCenterData.workPlaceId, recreationCenterData.structuralUnit).then((result) => {
      let recreationCenterCategories  = result.data;
      
      commit('set', { type: 'recreationCenterCategories', value: recreationCenterCategories })
      commit('set', { type: 'recreationCenterDays', value: [] })
    })
  },
  getRecreationCenterDays({ commit }, daysData) {
    return dataAPI.recreationCenter.fetchDays(daysData.categoryId, daysData.year, 'FREE').then((result) => {
      const recreationCenterDays = result.data;
      
      recreationCenterDays.sort((a, b) => {
        const parts1 = a.entrance_days.split("-")[0].split(".");
        const year1 = parseInt(parts1[2].slice(0, 2), 10) + 2000;
        const month1 = parseInt(parts1[1], 10) - 1;
        const day1 = parseInt(parts1[0], 10);
        const dateA = new Date(year1, month1, day1);

        const parts2 = b.entrance_days.split("-")[0].split(".");
        const year2 = parseInt(parts2[2].slice(0, 2), 10) + 2000;
        const month2 = parseInt(parts2[1], 10) - 1;
        const day2 = parseInt(parts2[0], 10);
        const dateB = new Date(year2, month2, day2);
        return dateA - dateB;
      });
      
      commit('set', { type: 'recreationCenterDays', value: recreationCenterDays })
    })
  },
  getRecreationCenterDayStatus({ commit }, id) {
    return dataAPI.recreationCenter.getRecreationCenterDayStatus(id).then((result) => {
      return result.data[0].status;
    })
  },
  getSpaTreatments({ commit }, region) {
    return dataAPI.spaTreatment.fetchAll().then((result) => {
      if(region === 'zhairem' || region === 'kokshetau'){
        const spaTreatments = [];
        result.data.forEach(function(spa){
          if(region === 'zhairem' && spa.id === 14){
            spaTreatments.push(spa);
          } else if(region === 'kokshetau' && (spa.id === 9 || spa.id === 8)){
            spaTreatments.push(spa);
          }          
        });
        commit('set', { type: 'spaTreatments', value: spaTreatments })
      } else {
        const spaTreatments = result.data;
        commit('set', { type: 'spaTreatments', value: spaTreatments })
      }            
    })
  },
  getSpaTreatmentCategories({ commit }, spaTreatmentData) {
    return dataAPI.spaTreatment.fetchCategories(spaTreatmentData.spaTreatmentId, spaTreatmentData.regionId, spaTreatmentData.workPlaceId).then((result) => {
      let spaTreatmentCategories  = [];
      result.data.forEach(function(category){
          spaTreatmentCategories.push(category);
      });
      commit('set', { type: 'spaTreatmentCategories', value: spaTreatmentCategories })
      commit('set', { type: 'spaTreatmentDays', value: [] })
    })
  },
  getSpaTreatmentDays({ commit }, daysData) {
    return dataAPI.spaTreatment.fetchDays(daysData.categoryId, daysData.year, 'FREE').then((result) => {
      const spaTreatmentDays = result.data;
      commit('set', { type: 'spaTreatmentDays', value: spaTreatmentDays })
    })
  },
  getSpaTreatmentDayStatus({ commit }, id) {
    return dataAPI.spaTreatment.getSpaTreatmentDayStatus(id).then((result) => {
      return result.data[0].status;
    })
  },
  getDispensarys({ commit }) {
    return dataAPI.dispensary.fetchAll().then((result) => {
      const dispensarys = result.data;
      commit('set', { type: 'dispensarys', value: dispensarys })
    })
  },
  getDispensaryCategories({ commit }, dispensaryData) {
    return dataAPI.dispensary.fetchCategories(dispensaryData.dispensaryId, dispensaryData.regionId, dispensaryData.workPlaceId).then((result) => {
      let dispensaryCategories  = [];
      result.data.forEach(function(category){
//        if(category.structural_unit && (dispensaryData.structuralUnit.name === category.structural_unit || dispensaryData.structuralUnit.name.indexOf(category.structural_unit) > 0)){
          dispensaryCategories.push(category);
//        }
      });
      commit('set', { type: 'dispensaryCategories', value: dispensaryCategories })
      commit('set', { type: 'dispensaryDays', value: [] })
    })
  },
  getDispensaryDays({ commit }, daysData) {
    return dataAPI.dispensary.fetchDays(daysData.categoryId, daysData.year, 'FREE').then((result) => {
      const dispensaryDays = result.data;
      commit('set', { type: 'dispensaryDays', value: dispensaryDays })
    })
  },
  getDispensaryDayStatus({ commit }, id) {
    return dataAPI.dispensary.getDispensaryDayStatus(id).then((result) => {
      return result.data[0].status;
    })
  },
  getSummerHealthCampsAll({ commit }) {
    return dataAPI.summerHealthCamp.fetchAll().then((result) => {
      let summerHealthCamps  = [];
      result.data.forEach(function(camp){
          summerHealthCamps.push(camp);
      });
      commit('set', { type: 'summerHealthCamps', value: summerHealthCamps })
    })
  },
  getSummerHealthCamps({ commit }, regionId) {
    return dataAPI.summerHealthCamp.fetchAll().then((result) => {
      let summerHealthCamps  = [];
      result.data.forEach(function(camp){
        if(camp.name == 'ДОЛ «KidsCamp» be free '){
          if(regionId == 'zhairem'){
            summerHealthCamps.push(camp);
          }          
        } else {
          summerHealthCamps.push(camp);
        }
      });
      commit('set', { type: 'summerHealthCamps', value: summerHealthCamps })
    })
  },
  getSummerHealthCampCategories({ commit }, summerHealthCampData) {
    return dataAPI.summerHealthCamp.fetchCategories(summerHealthCampData.summerHealthCampId, summerHealthCampData.regionId, summerHealthCampData.workPlaceId).then((result) => {
      let summerHealthCampCategories  = [];

      result.data.forEach(function(category){        
        let satisfy = !category.structural_unit ||
                      category.structural_unit == '' ||
                      summerHealthCampData.structuralUnit.name === category.structural_unit ||
                      summerHealthCampData.structuralUnit.name.toLowerCase().indexOf(category.structural_unit.toLowerCase()) > -1;

        if(!satisfy && summerHealthCampData.structuralUnit.name.length > 0){
          let structuralUnitLevels = summerHealthCampData.structuralUnit.name.toLowerCase().split(' / ');
          let categoryLevels = category.structural_unit.toLowerCase().split(' / ');

          if(categoryLevels.length == 1){
            satisfy = structuralUnitLevels[0].length >= categoryLevels[0].length && structuralUnitLevels[0].startsWith(categoryLevels[0]);
            if(!satisfy){
              satisfy = structuralUnitLevels[0].length < categoryLevels[0].length && categoryLevels[0].startsWith(structuralUnitLevels[0]);
            }  
          }
          if(!satisfy && categoryLevels.length == 2 && structuralUnitLevels.length > 2){
            satisfy = structuralUnitLevels[0] == categoryLevels[0] && structuralUnitLevels[1] == categoryLevels[1]; 
          }
          if(!satisfy && categoryLevels.length == 3 && structuralUnitLevels.length > 3){
            satisfy = structuralUnitLevels[0] == categoryLevels[0] && structuralUnitLevels[1] == categoryLevels[1] && structuralUnitLevels[2] == categoryLevels[2]; 
          }
        }
        if(satisfy){
          summerHealthCampCategories.push(category);
        }
      });
      commit('set', { type: 'summerHealthCampCategories', value: summerHealthCampCategories })
      commit('set', { type: 'summerHealthCampDays', value: [] })
    })
  },
  getSummerHealthCampDays({ commit }, daysData) {
    return dataAPI.summerHealthCamp.fetchDays(daysData.summerHealthCampId, daysData.year, daysData.categoriesListIds, 'FREE').then((result) => {
      const summerHealthCampDays = result.data;

      summerHealthCampDays.sort((a, b) => {
        const parts1 = a.entrance_days.split("-")[0].split(".");
        const year1 = parseInt(parts1[2].slice(0, 2), 10) + 2000;
        const month1 = parseInt(parts1[1], 10) - 1;
        const day1 = parseInt(parts1[0], 10);
        const dateA = new Date(year1, month1, day1);

        const parts2 = b.entrance_days.split("-")[0].split(".");
        const year2 = parseInt(parts2[2].slice(0, 2), 10) + 2000;
        const month2 = parseInt(parts2[1], 10) - 1;
        const day2 = parseInt(parts2[0], 10);
        const dateB = new Date(year2, month2, day2);
        return dateA - dateB;
      });

      commit('set', { type: 'summerHealthCampDays', value: summerHealthCampDays })
    })
  },
  getSummerHealthCampDayStatus({ commit }, id) {
    return dataAPI.summerHealthCamp.getSummerHealthCampDayStatus(id).then((result) => {
      return result.data[0].status;
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/data.js